export default __webpack_public_path__ + "static/media/benneregular.b3385bdb.txt";